var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.45046 1.42404C9.88256 -0.00804746 12.2042 -0.00804746 13.6363 1.42404C15.0684 2.85614 15.0684 5.17778 13.6363 6.60988L8.0118 12.2344C7.11556 13.1306 5.66185 13.1306 4.76561 12.2344C3.86937 11.3381 3.86937 9.88443 4.76561 8.98819L9.0322 4.72159C9.28604 4.46775 9.6976 4.46775 9.95144 4.72159C10.2053 4.97543 10.2053 5.38699 9.95144 5.64083L5.68485 9.90742C5.29629 10.296 5.29629 10.9266 5.68485 11.3151C6.07341 11.7037 6.704 11.7037 7.09256 11.3151L12.7171 5.69064C13.6415 4.76623 13.6415 3.26769 12.7171 2.34328C11.7926 1.41887 10.2941 1.41887 9.3697 2.34328L3.7452 7.96778C2.28494 9.42805 2.28494 11.7945 3.7452 13.2548C5.20547 14.715 7.57194 14.715 9.0322 13.2548L12.4456 9.84135C12.6995 9.58751 13.111 9.58751 13.3649 9.84135C13.6187 10.0952 13.6187 10.5067 13.3649 10.7606L9.95144 14.174C7.9835 16.142 4.79391 16.142 2.82596 14.174C0.85802 12.2061 0.85802 9.01649 2.82596 7.04854L8.45046 1.42404Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.f8e97dafb266748d4a053618fd433846.svg";
export { ForwardRef as ReactComponent };